<template>
  <com-solt title="欢迎注册" :isShopView="isShopView" :GetShopInfoNoLogin="GetShopInfoNoLogin">
    <div class="main">
      <div class="content container1">
        <div class="have_number">
          <span>已有账号？ <span class="im_login" @click="goLogin">立即登录</span></span>
        </div>

        <el-form ref="form" :model="dataRegister" :rules="rules" label-width="174px" label-position="left">
          <el-form-item label="手机号码：" prop="mobile">
            <el-input v-model="dataRegister.mobile" clearable></el-input>
          </el-form-item>
          <el-form-item class="code" label="手机验证码：" prop="verCode">
            <el-input v-model="dataRegister.verCode" clearable></el-input>
            <el-button @click="sendVerCode" :disabled="downTime>0" type="primary send_btn">{{downTime>0?downTime+'秒后重发':'发送验证码'}}</el-button>
          </el-form-item>
          <el-form-item label="密码：" prop="password">
            <el-input v-model="dataRegister.password" show-password auto-complete="new-password" clearable></el-input>
          </el-form-item>
          <el-form-item label="确认密码：" prop="password_conf">
            <el-input v-model="dataRegister.password_conf" show-password clearable></el-input>
          </el-form-item>
          <el-form-item label="验证：" prop="valueSlider">
            <drag-verify ref="dragVerify" class="verify" :isPassing.sync="dataRegister.valueSlider" :width="306" :height="30" textSize="12px" radius="0px" text="请按住滑块，拖动到最右边" success-text="验证通过" handlerIcon="fa el-icon-d-arrow-right" successIcon="fa el-icon-circle-check"></drag-verify>
          </el-form-item>
          <el-form-item>
            <el-button type="primary btn" :loading="loading" @click="register">同意注册</el-button>
          </el-form-item>
          <el-form-item prop="clause">
            <el-checkbox v-model="dataRegister.clause">同意《多比网服务条款》和《隐私条款》</el-checkbox>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </com-solt>
</template>

<script>
import ComSolt from "./components/comSolt";
import dragVerify from "vue-drag-verify2";
import {
  checkSlider,
  checkVerCode,
  validMobile,
} from "@/pages/publicUtils/validate";
export default {
  metaInfo: { title: "个人注册" },
  name: "register",
  components: {
    dragVerify,
    ComSolt,
  },
  props: {
    UserRegister: {
      type: Function,
      default: () => {},
    },
    GetVerCode: {
      type: Function,
      default: () => {},
    },
    CheckMobileIsRegisted: {
      type: Function,
      default: () => {},
    },
    GetShopInfoNoLogin: {
      type: Function,
      default: () => {},
    },
    isShopView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    let checkMobile = async (rule, value, callback) => {
      if (!value) {
        return callback(new Error("必填"));
      }
      if (!validMobile(value)) {
        return callback(new Error("格式不对"));
      }
      if (value && validMobile(value)) {
        let result = await this.mobileIsRegister();
        if (result.data[0].isRegisted == 1) {
          return callback(new Error("手机号已被注册"));
        }
        callback();
      }
    };
    let checkPass = (rule, value, callback) => {
      if (!value) {
        callback(new Error("必填"));
      } else {
        if (value.indexOf(" ") != -1) {
          return callback(new Error("不能输入空格"));
        }
        if (this.dataRegister.password_conf) {
          this.$refs.form.validateField("password_conf");
        }
        callback();
      }
    };
    let checkConf = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("必填"));
      }
      if (value != this.dataRegister.password) {
        return callback(new Error("两次输入密码不一致!"));
      }
      callback();
    };
    let checkClause = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请勾选"));
      }
      callback();
    };
    return {
      downTime: 0,
      //注册页面数据
      dataRegister: {
        mobile: undefined,
        verCode: undefined,
        password: undefined,
        password_conf: undefined,
        valueSlider: false,
        clause: false,
      },
      rules: {
        mobile: [{ validator: checkMobile, required: true, trigger: "blur" }],
        valueSlider: [
          { validator: checkSlider, required: true, trigger: "change" },
        ],
        verCode: [{ validator: checkVerCode, required: true, trigger: "blur" }],
        password: [{ validator: checkPass, required: true, trigger: "blur" }],
        password_conf: [
          { validator: checkConf, required: true, trigger: "blur" },
        ],
        clause: [{ validator: checkClause, required: true, trigger: "change" }],
      },
      loading: false,
    };
  },
  methods: {
    register() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.UserRegister(this.dataRegister)
            .then((res) => {
              // console.log("用户注册结果", res);
              this.loading = false;
              this.goLogin();
            })
            .catch((err) => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },
    goLogin() {
      let newUrl = this.$router.resolve({
        path: "/login",
        query: this.$route.query,
      });
      window.open(newUrl.href, "_self");
    },
    sendVerCode() {
      this.$refs.form.validateField("mobile", (err) => {
        if (!err) {
          this.GetVerCode({ mobile: this.dataRegister.mobile }).then((res) => {
            // console.log("获取到的验证码", res);
            this.dataRegister.verCode = res.data[0].verCode;
            this.downTime = 60;
            let aTime = setInterval(() => {
              this.downTime -= 1;
              // console.log(this.downTime);
              if (this.downTime <= 0) {
                clearInterval(aTime);
              }
            }, 1000);
          });
        }
      });
    },
    mobileIsRegister() {
      return new Promise((resolve) => {
        let params = { mobile: this.dataRegister.mobile };
        this.CheckMobileIsRegisted(params).then((res) => {
          // console.log("验证手机是否注册", res);
          resolve(res);
        });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  height: 598px;
  border: 1px solid @themeColor;
  border-left: none;
  border-right: none;
  .content {
    padding-top: 14px;
    .have_number {
      font-size: 14px;
      font-weight: 500;
      color: #1a1a1a;
      text-align: right;
      .im_login {
        color: #ff9e00;
        cursor: pointer;
      }
    }
    /deep/ .el-form {
      margin-top: 102px;
      margin-left: 280px;
      .el-form-item__label {
        font-size: 14px;
        font-weight: 500;
        color: #1a1a1a;
        line-height: 30px;
      }
      .el-form-item__content {
        width: 306px;
        line-height: 30px;
        .el-input__inner {
          height: 30px;
          line-height: 30px;
        }
        .el-input__suffix {
          height: 30px;
          line-height: 30px;
          .el-input__icon {
            line-height: 30px;
          }
        }
        .el-form-item__error {
          width: 180px;
          height: 30px;
          padding: 0;
          box-sizing: border-box;
          line-height: 30px;
          top: 0;
          left: 110%;
          color: #909090;
        }
        .btn {
          width: 100%;
          background: #b7b7b7;
          border-radius: 0;
          border-color: #b7b7b7;
          font-size: 16px;
          font-weight: 500;
          &:active {
            opacity: 0.8;
          }
        }
      }
      .code {
        .el-form-item__content {
          .el-input__inner {
            padding-right: 127px;
            box-sizing: border-box;
          }
          .send_btn {
            position: absolute;
            right: 1px;
            top: 1px;
            border-radius: 0;
            background: #ffffff;
            font-weight: 500;
            color: #b7b7b7;
            height: 28px;
            line-height: 1;
            padding: 0 10px 0 0;
            margin-left: 30px;
            border: none;
            font-size: 12px;
          }
          .el-input__suffix {
            right: 100px;
          }
        }
      }
    }
  }
}
</style>